
import { FirearmStorageLocationEntityDecoratorBase } from './firearm-storage-location.decorator.base';


export class FirearmStorageLocationEntityDecorator extends FirearmStorageLocationEntityDecoratorBase {
  constructor() {
    super();
  }
}



